import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Popup from 'reactjs-popup';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Moment from 'react-moment';
import moment from 'moment';
import ReactToPrint from 'react-to-print';

import ReactHTMLTableToExcel from 'react-html-table-to-excel';
let strStaff=[{title:'',year:0}];
const headCells = [
  
  { id: 'st_name', numeric: false, label: 'Name' },
  { id: 'lm_createddate', numeric: false, label: 'Date' },
    { id: 'leavetype', numeric: false, label: 'Type' },
	 { id: 'leavetypes', numeric: false, label: 'Leave Purpose' },
	{ id: 'fromdate', numeric: false, label: 'From Date' },
{ id: 'todate', numeric: false, label: 'To Date' },
	 { id: 'leavestatus', numeric: false, label: 'Status' },

  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
const style = ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
});

export default class Leadmasterreport extends Component {
	
			constructor(props) {
    super(props);
	const now = dayjs();
const startOfMonth = now.startOf('month');
const today = now;
	
	this.state = {edirect: false,
      Leavereportdata:[],lmid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],exportdata:[],
	 
	  order:'desc' ,orderBy:'',names:'',searchsubscription:'',type:'', lvstatus:'',user:'',
	  //fromdate:dayjs(Date.now()),fromdate1:'',todate:dayjs(Date.now()),todate1:'',
	  fromdate: startOfMonth,
  fromdate1: startOfMonth.format('YYYY-MM-DD'),
  todate: today,
  todate1: today.format('YYYY-MM-DD'),
	  staffarray:[],staffauto:[],stafftid:'',selectval:[]
    }
      
	  };
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
  
  
  this.setState({[nam]: val});

 } 
  handleClickSearch=()=>{    
  this.apicall(this.state.page,this.state.rowsPerPage);	
} 
	componentDidMount  () {	
	
	
	document.title = "AthaYog Living - Leave Report";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	

	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  
} 

	
apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxreport.php?action=Leavereport&lm_type='+this.state.type+'&lm_createduserid='+this.state.user+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&lm_status='+this.state.lvstatus+'&Sorting='+page+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Leavereportdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
			   

		    });
	  
	 this.Apiexportcall();
	 
     }
	 else{
		   this.setState({Leavereportdata:[],totaldata:0});
	 }
 
    });
}
	
Apiexportcall(){
	 
	 axios.get(Serverurl+'ajaxreport.php?action=Leavereport&lm_type='+this.state.type+'&lm_createduserid='+this.state.user+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&lm_status='+this.state.lvstatus)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  exportdata: resp.data,  
			  
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({exportdata:[]});
	 }
 
    });
}
	  
handfromChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ fromdate:dayjs(date),
fromdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
todate: todate1,
todate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
	
  }
  handtoChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ todate:dayjs(date),
todate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
 
onloadStaffBind=(event)=>{
	if(event.target.value.length>2 )
	{
		axios.get(Serverurl+'ajaxstaff.php?action=getall&st_name='+event.target.value).then(resp => { 
		this.setState({ staffarray:resp.data,staffauto:[]});

			var rowsArray = this.state.staffarray;
			rowsArray.map((row, i) => {			 
				let j=(i+1);			
				const items = {
					title:row.st_name,
					year:row.st_id,
						 
				};
			
			    const found = strStaff.some(el => el.year === row.year);
				
		 if (!found){ strStaff.push(items);}
			});
		 
		this.setState({staffauto:strStaff},()=>{console.log(strStaff)})
		}); 
	}
}
onInputCustChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({stafftid:newTextValue})
	} 
}
onTagscustomerexchange = (event, values) => {
	if(values!==" " && values!==null){
		this.setState({
		stafftid:values.year,
		user:values.year,
		selectval:values},()=>{})
	}
	else
	{
		 this.setState({ custid:'',or_cu_id:'',selectedcustomerexchange:[]})
	}
}
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
  

<div className="boxheading">
				 
<h2>Leaves Report</h2>
</div>

<div className="clear">
</div>

   <div className="searchmaster">


  
  <ul>
  <li>
 <p>From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox" 
    onChange={this.handfromChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox" 
    onChange={this.handtoChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 <li> <p>Staff</p>
 <p>
<Autocomplete
      id="free-solo-demo"
      
      className="txtbox"  inputValue={this.state.stafftid}
      options={this.state.staffauto}   onInputChange={this.onInputCustChange}
	   onChange={this.onTagscustomerexchange} 
	    value={this.state.selectval}
      renderInput={(params) => (
        <TextField {...params} className="txtbox" onChange={this.onloadStaffBind}  variant="outlined" />
      )}
 getOptionLabel={(option) => option.title || ""}  /></p>
 </li>
 <li>	
		 <p>Leave Type</p> 
		  <p> <FormControl  className="stadrp">
       
        <Select
		variant="outlined"
        native
         value={this.state.type}
		 inputProps={{ tabIndex: "3" }}
          onChange={this.myChangeHandler} className="txtbox"
        name='type'
         id='type'
		 fullWidth
		 
        >
		   
          <option value={''}>Select Type</option>
          <option value={1}>Permission</option>
          <option value={2}>Leave</option>
		  
          </Select>
      </FormControl>
		  	   </p>
			   </li>
			   
			

<li>
<p>Leave Status</p> 
 <p> <FormControl  className="stadrp">
       
        <Select
		variant="outlined"
        native
         value={this.state.lvstatus}
          onChange={this.myChangeHandler} className="txtbox"
        name='lvstatus'
         id='lvstatus'
		 fullWidth  inputProps={{ tabIndex: "4" }}
		 
        >
		   
          <option value={''}>Select Status</option>
		  <option value={0}>Waiting For Approval</option>
          <option value={1}>Approved</option>
          <option value={2}>Rejected</option>	  
		  <option value={4}>Absent without permission</option>
          </Select>
      </FormControl>
		  	   </p>
</li>		
		
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="leavereport"
							filename="Leave Report"
							sheet="Leave Report"
							buttonText="EXPORT"/>

	  
	  </p></li> 
		
		
		
		
		</ul>
		
</div>		


<div ref={el => (this.componentRef = el)} style={{"margin-left":"20px","fontFamily":"Arial","margin-top":"10px","fontSize":"15px"}} >

<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" >  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Leavereportdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Leavereportdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >

<TableCell>{item.st_name}</TableCell>
<TableCell>{item.applieddate}</TableCell>
<TableCell>{item.leavetype}</TableCell>
<TableCell>{item.leavetypes}</TableCell>

{item.lm_type === "2" && ( <React.Fragment>
<TableCell>{item.lm_fromdate}</TableCell>
<TableCell>{item.lm_todate}</TableCell>
	</React.Fragment>)}

	{item.lm_type === "1" && ( <React.Fragment>

<TableCell>{item.fromtime}</TableCell>
<TableCell>{item.totime}</TableCell>
</React.Fragment>)}
<TableCell>{item.leavestatus}</TableCell>

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
       
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onChangePage={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
</div>


<div style={{"display":"none"}}>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="leavereport">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.exportdata.length}
            />
                      <TableBody>
                     {this.state.exportdata.map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >

<TableCell>{item.st_name}</TableCell>
<TableCell>{item.applieddate}</TableCell>
<TableCell>{item.leavetype}</TableCell>
<TableCell>{item.leavetypes}</TableCell>

{item.lm_type === "2" && ( <React.Fragment>
<TableCell>{item.lm_fromdate}</TableCell>
<TableCell>{item.lm_todate}</TableCell>
	</React.Fragment>)}

	{item.lm_type === "1" && ( <React.Fragment>

<TableCell>{item.fromtime}</TableCell>
<TableCell>{item.totime}</TableCell>
</React.Fragment>)}
<TableCell>{item.leavestatus}</TableCell>

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
   
  </Paper></div>
 </React.Fragment> 

 
 
  );
}
	
	
}

  